export const FormatDate = (date) => {
    if(!date) return date;
    const date1 = new Date(date).toLocaleDateString("en-US", {
      day:"2-digit", month:'2-digit', year:'numeric'
    })
    return date1;
  }